import { useNavigate } from 'react-router-dom';
import { cloneElement, isValidElement } from 'react';

import CustomTour from 'components/shared/Tour/CustomTour';

import DelegationTasksIntro from '../DelegationTasksIntro/DelegationTasksIntro';

const renderIntro = ({ IntroComponent, consultant, onEndIntro }) => {
  if (!isValidElement(IntroComponent)) return IntroComponent;
  return cloneElement(IntroComponent, {
    onEndIntro: (...args) => {
      onEndIntro();
      IntroComponent.props?.onEndIntro?.(...args);
    },
    consultant
  });
};

const StepperOverlays = ({
  showTour,
  tourStepsConfig,
  onTourClose,
  showIntro,
  IntroComponent,
  consultant,
  wizardInstance,
  currentUserId,
  isAuthenticated,
  isAdmin,
  setShowIntro,
  startTourIfUnseen,
  showTasksIntro,
  setShowTasksIntro,
  assignedTasks,
  setNavigateToCode
}) => {
  const navigate = useNavigate();

  const isAssignedToOther =
    Boolean(wizardInstance?.assigned_to) && wizardInstance?.assigned_to !== currentUserId;

  const showDelegationIntro =
    isAssignedToOther && assignedTasks.length > 0 && !isAdmin && showTasksIntro;

  // The delegation intro replaces the general intro — rendering both stacks two
  // full-screen overlays and the tour would anchor to a layout pushed off-screen.
  const renderedIntro =
    showIntro && isAssignedToOther && !showDelegationIntro
      ? renderIntro({
          IntroComponent,
          consultant,
          onEndIntro: () => {
            setShowIntro(false);
            if (isAuthenticated) startTourIfUnseen();
          }
        })
      : null;

  const dismissDelegationIntro = () => {
    setShowTasksIntro(false);
    setShowIntro(false);
    if (isAuthenticated) startTourIfUnseen();
  };

  return (
    <>
      {showTour && <CustomTour steps={tourStepsConfig} onClose={onTourClose} />}
      {renderedIntro}
      {showDelegationIntro && (
        <DelegationTasksIntro
          title="Myriad Health"
          description="The most comprehensive practice management system ever created."
          onEndIntro={dismissDelegationIntro}
          onSkip={() => navigate('/portal')}
          navigateToTask={(code) => {
            setNavigateToCode(code);
            dismissDelegationIntro();
          }}
          tasks={assignedTasks}
        />
      )}
    </>
  );
};

export default StepperOverlays;
